function sintomas(){
	return {
		"games":[
			{
				"informs":[
					{
						"text":"Os sintomas mais comuns são: tosse, dor de garganta, febre, coriza, dificuldade para respirar ou falta de ar.",
						"title":"Quais os sintomas da doença",
						"image":"images/games/informs/sintomas/1.png",
					},
					{
						"text":"perda do olfato, alteração do paladar, náusea, vômito, diarreia, cansaço e falta de apetite.",
						"title":"Quais os sintomas da doença",
						"image":"images/games/informs/sintomas/1.png",
					}
				],
				"pathImageGame":"midias/images/games/puzzles/sintomas/1.png"
			}
		]
	};
}

export {sintomas};
